(ns rothko.theme.manatee.form.radio
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [px rem]]))

(def radio
  {:vertical
   {:options-container-padding [[(rem 1) 0]]
    :options-container-flex-direction :column

    :first-option-padding [[0 0 (rem 0.5)]]
    :last-option-padding [[(rem 0.5) 0 0]]

    :option-align-items :center
    :option-padding [[(rem 0.5) 0]]

    :input-margin [[0 (rem 1) 0 0]]
    :input-width (px 14)
    :input-height (px 14)}

   :horizontal
   {:options-container-padding [[(rem 1) 0]]
    :options-container-flex-direction :row

    :first-option-padding [[0 (rem 1) 0 0]]
    :last-option-padding [[0 0 0 (rem 1)]]

    :option-flex-direction :column-reverse
    :option-align-items :center
    :option-padding [[0 (rem 1)]]

    :input-margin [[(rem 0.5) 0 0]]
    :input-width (px 14)
    :input-height (px 14)}})
